import React from "react";
import CallFooter from "../../assets/images/CallFooter.svg";
import FAQFooter from "../../assets/images/FAQFooter.svg";
import Homefooter from "../../assets/images/Homefooter.svg";
import SettingsFooter from "../../assets/images/SettingsFooter.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation()
  const navigate = useNavigate();
  const getProductFeaturesSelector = useSelector(
    (state) => state?.getProductFeatures
  );
  const activeToggle = (value) => {
    navigate(value, { state: getProductFeaturesSelector });
  };
  return (
    <>
      <footer className="">
        <div className="footer">
          <div
            className={`footerItem ${
              location?.pathname === "/dashboard" ? "active" : ""
            }`}
            onClick={() => activeToggle("/dashboard")}
          >
            <div className="text-center">
              <img src={Homefooter} alt="" />
            </div>
            <div className="fs-10">{t("Home")}</div>
          </div>
          <div
            className={`footerItem ${
              location?.pathname === "/contact" ? "active" : ""
            }`}
            onClick={() => activeToggle("/contact")}
          >
            <div className="text-center">
              <img src={CallFooter} alt="" />
            </div>
            <div className="fs-10">{t("Contact")}</div>
          </div>
          <div
            className={`footerItem ${
              location?.pathname === "/FAQs" ? "active" : ""
            }`}
            onClick={() => activeToggle("/FAQs")}
          >
            <div className="text-center">
              <img src={FAQFooter} alt="" />
            </div>
            <div className="fs-10">{t("FAQs")}</div>
          </div>
          <div
            className={`footerItem ${
              location?.pathname === "/settings"||location?.pathname === "/support-request" ||location?.pathname==="/manage-notification"? "active" : ""
            }`}
            onClick={() => activeToggle("/settings")}
          >
            <div className="text-center">
              <img src={SettingsFooter} alt="" />
            </div>
            <div className="fs-10">{t("Settings")}</div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
